import { render, staticRenderFns } from "./DraftMessagesTab.vue?vue&type=template&id=63e4b45b&scoped=true&"
import script from "./DraftMessagesTab.vue?vue&type=script&lang=js&"
export * from "./DraftMessagesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e4b45b",
  null
  
)

export default component.exports